<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="transparent"
        phoneHeaderFixed
        phoneBodyOverflowHidden
        phoneHeaderFixedColor="#fff"
      >
        <div
          class="slot"
          :style="{ backgroundImage: 'url(' + ruleForm.gameBgp + ')' }"
        >
          <div class="change-bg">
            <div
              class="upload-img pointer"
              v-if="ruleForm.gameBgp"
              @click="toggleShow('bg')"
            >
              更换背景
            </div>
          </div>
          <!-- <div class="title-img-wrapper redeem-upload prev-upload" v-if="styleType=='virtualize' || styleType2=='virtualize'">
            <div
              class="upload-img"
              v-if="ruleForm.gameBgp3"
              @click="toggleShow('virtualize')"
            >
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img02" :src="ruleForm.gameBgp3" alt="" />
          </div> -->
          <div class="title-img-wrapper redeem-upload prev-upload">
            <div
              class="upload-img"
              v-if="ruleForm.gameBgp2"
              @click="toggleShow"
            >
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img" :src="ruleForm.gameBgp2" alt="" />
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container ">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
        >
          <div id="base">1.基本信息</div>
          <el-form-item label="活动名称" prop="gameName">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameName"
              placeholder="请输入活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动报名时间" prop="activityDate">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.activityDate"
              :picker-options="pickerOptions0"
              type="datetimerange"
              align="right"
              start-placeholder="活动报名开始时间"
              end-placeholder="活动报名结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              v-if="!type"
            ></el-date-picker>
            <div v-if="type">
              开始时间：
              <el-date-picker
                      :disabled="type === 'details'"
                      v-model="ruleForm.activityDate[0]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      placeholder="开始时间"
                      size="small"
                      class="mr10"
              >
              </el-date-picker>
            </div>
            <div v-if="type">
              结束时间：
              <el-date-picker
                      size="small"
                      :editable="false"
                      v-model="ruleForm.activityDate[1]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="'23:59:59'"
                      placeholder="结束时间"
                      :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <!-- <el-form-item label="虚拟开奖时间" prop="autoOpenTime" v-if="styleType=='virtualize' || styleType2=='virtualize'">
            <el-date-picker
              format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.autoOpenTime"
              type="datetime"
              :picker-options="pickerOptions"
              style="width: 400px"
              align="right"
              placeholder="虚拟开奖时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
            <div class="form-tip">
              到达虚拟开奖后不会真实开奖，仅提示用户去其它地方领奖
            </div>
          </el-form-item> -->
          <el-form-item label="开奖时间" prop="autoOpenTime">
            <el-date-picker
              format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.autoOpenTime"
              type="datetime"
              :picker-options="pickerOptions"
              style="width: 400px"
              align="right"
              placeholder="开奖时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="活动分享文案" prop="gameShareContent">
            <el-input
              style="width: 400px"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 7 }"
              placeholder="请输入活动分享文案"
              v-model.trim="ruleForm.gameShareContent"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="活动背景图：" prop="gameBgp">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="imgwidth"
              :height="imgheight"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>

            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow('bg')"
                v-if="!ruleForm.gameBgp"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传背景图</span>
              </div>

              <div v-if="ruleForm.gameBgp" class="mr10 flex item-end priview">
                <img class="logo" :src="ruleForm.gameBgp" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow('bg')"
                    >更换</el-button
                  >
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议750x1334（最多上传一张）
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="活动焦点图：" prop="gameBgp3">
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow('virtualize')"
                v-if="!ruleForm.gameBgp3"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传焦点图</span>
              </div>

              <div
                v-if="ruleForm.gameBgp3"
                class="mr10 flex item-end priviewheadline priviewheadlineNew"
              >
                <img class="logo" :src="ruleForm.gameBgp3" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow('virtualize')">删除</el-button>
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议456x103（最多上传一张）
              </div>
            </div>
          </el-form-item> -->
          <el-form-item label="活动焦点图：" prop="gameBgp2">
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow"
                v-if="!ruleForm.gameBgp2"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传主图</span>
              </div>

              <div
                v-if="ruleForm.gameBgp2"
                class="mr10 flex item-end priviewheadline"
              >
                <img class="logo" :src="ruleForm.gameBgp2" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow">删除</el-button>
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议750x580（最多上传一张）
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动规则说明" prop="gameRuleRemark">
            <hm-rich-editor
              v-model="ruleForm.gameRuleRemark"
              :html="ruleForm.gameRuleRemark"
            />
          </el-form-item>
          <div id="base">2助力规则配置区</div>
          <el-form-item label="助力规则配置" prop="shareValue">
            <div>
              <p>每邀请一个好友助力值增加
              <el-input
                type="number"
                maxlength="10"
                @mousewheel.prevent.native
                style="width: 150px"
                size="small"
                clearable
                class="mr10 ipt"
                @input="filterGt0('shareValue')"
                v-model.trim="ruleForm.shareValue"
                placeholder="请输入数量"
              ></el-input
              >个</p>
              <p>最多助力次数
              <el-input
                type="number"
                maxlength="10"
                @mousewheel.prevent.native
                style="width: 150px"
                size="small"
                clearable
                class="mr10 ipt"
                @input="filterGt0('shareTotal')"
                v-model.trim="ruleForm.shareTotal"
                placeholder="请输入次数"
              ></el-input
              >次</p>
            </div>
          </el-form-item>
          <el-form-item label="活动奖品设置" prop="drawTypeList">
              <el-table
                :data="rules.turntablePrizeRuleList"
                style="width: 100%"
                ref="table"
                border
                stripe
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖项"
                  prop="rankingSeqNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.rankingSeqNum"
                        placeholder="请输入奖项"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品类型"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-select
                        clearable
                        size="small"
                        style="width:100%"
                        v-model="scope.row.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="积分" value="1"></el-option>
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品内容"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        v-if="scope.row.prizeType == '1'"
                        style="width:100%"
                        v-model.trim="scope.row.typeValue"
                        @input="filterGt0OrFixed('typeValue', scope.$index)"
                        size="small"
                        clearable
                        placeholder="奖品积分"
                      ></el-input>
                      <el-input
                        v-if="scope.row.prizeType == '3'"
                        style="width:100%"
                        v-model.trim="scope.row.typeValue"
                        size="small"
                        clearable
                        placeholder="实物名称"
                      ></el-input>
                      <el-select
                        v-if="scope.row.prizeType == '2'"
                        clearable
                        size="small"
                        style="width:100%"
                        v-model="scope.row.typeValue"
                        placeholder="请选择优惠券"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.couponSendId"
                          v-for="(item, i) in couponList"
                          :key="i"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品名称"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeName"
                        placeholder="奖品名称"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品图片"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        class="flex goods-upload-btn"
                        @click="addGoodsImg(scope.row, 'prizeImg')"
                        v-if="!scope.row.prizeImg"
                      >
                        <div
                          style="margin-left:0px"
                          class="btn flex flex-column flex-center open-file item-center"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                      </div>
                      <div v-else class="mr10 flex item-end priviews">
                        <!-- <img class="logo" :src="scope.row.prizeImg" alt="logo" /> -->
                        <el-image
                          class="img"
                          :src="scope.row.prizeImg"
                          alt="logo"
                          :preview-src-list="[scope.row.prizeImg]"
                        />
                        <div
                          class="opreat-wrapper flex item-center flex-center"
                        >
                          <el-button
                            type="text"
                            @click="handleRemove(scope.$index)"
                            >删除</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品数量"
                  prop="prizeNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeNum"
                        placeholder="请输入数量"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="单人中奖上限"
                  prop="eachPrizeWinningUpperLimit"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'eachPrizeWinningUpperLimit')"
                        v-model.trim="scope.row.eachPrizeWinningUpperLimit"
                        placeholder="请输入单人中奖上限"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="winningRate"
                >
                  <template slot="header">
                    <span class="mr10">中奖率</span>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                    >
                      <div>
                        中奖率合计不能超过100%
                      </div>
                      <span slot="reference">
                        <i class="el-icon-question" style="fontSize:20px"></i>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <div class="flex item-center p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="18"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'winningRate')"
                        v-model.trim="scope.row.winningRate"
                        placeholder="中奖率"
                      ></el-input
                      >%
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="出奖门槛（总抽奖数到达多少次）"
                  prop="awardThreshold"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center">
                      <el-input
                        size="small"
                        clearable
                        class="mr10 ml10 ipt"
                        maxlength="18"
                        style="width:100px"
                        @input="
                          filterGt0OrFixed0(scope.$index, 'awardThreshold')
                        "
                        v-model.trim="scope.row.awardThreshold"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSn"
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        style="margin-left:0px"
                        class="add-wrapper flex flex-center"
                        v-if="scope.$index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addChild(scope.$index)"
                        ></span>
                      </div>
                      <div
                        style="margin-left:0px"
                        class="minus-wrapper flex flex-center"
                        v-else
                      >
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteChild(scope.$index)"
                        ></span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
        </el-form>
        <div class="flex flex-center mt10">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            >发布</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess1"
          @crop-upload-fail="cropUploadFail"
          v-model="showPrizeImg"
          v-if="showPrizeImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'goodsCenter' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
      </div>
    </div>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
export default {
  components: { myUpload, HmRichEditor, actPreview },
  data() {
    const rewardValueFunc = function(rule, val, callback) {
      
      if (!this.ruleForm.rewardValue) {
        return callback(new Error("请输入开奖门槛"));
      }

      if (!this.ruleForm.addValue) {
        return callback(new Error("请输入手动增加助力值"));
      }

      callback();
    }.bind(this);
    const patterndDrawTypeListFunc = function(rule, val, callback) {
      let flag = true;
      let winningRateTotal = 0;
      this.rules.turntablePrizeRuleList.map(v => {
        if (
          !v.rankingSeqNum ||
          !v.prizeType ||
          !v.typeValue ||
          !v.prizeName ||
          !v.prizeNum ||
          
          (!v.winningRate && v.winningRate != 0)
        ) {
          flag = false;
        }
        winningRateTotal += v.winningRate * 1;
      });
      if (flag) {
        if (winningRateTotal > 100) {
          return callback(new Error("中奖率合计不能超过100%!"));
        }
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    const shareValueFunc = function(rule, val, callback) {
      
      if (!this.ruleForm.shareValue) {
        return callback(new Error("用户填写助力值数量"));
      }

      if (!this.ruleForm.shareTotal) {
        return callback(new Error("用于限制累计助力的最大次数"));
      }


      callback();
    }.bind(this);
    return {
      styleType:"",
      styleType2:"",
      imgwidth: 0,
      imgheight: 0,
      show: false,
      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      uploadType: "",
      pickerOptions: {
        disabledDate: this.disabledDates
      },
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      ruleForm: {
        activityDate: "",
        autoOpenTime: "",
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgp2:
          "https://imgcdn.hemiao100.com/static/dscj-head.png",
        gameBgp:
          "https://imgcdn.hemiao100.com/static/dingshichoujiang-bg.png",
        gameBgp3:
          "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/title.png",  
        winnerNum: "",
        isDefaultWinner: "no",
        rewardValue: "",
        addValue: "",
        aliasName: "",
        shareValue: "",
        shareTotal: "",
        totalHelpValue: 0,
        couponList: [],
      },
      rules: {
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        activityDate: {
          required: true,
          message: "请输入活动时间",
          trigger: "blur"
        },
        autoOpenTime: {
          required: true,
          message: "请输入开奖时间",
          trigger: "blur"
        },
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        gameBgp: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        gameBgp2: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameBgp3: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        winnerNum: [
          {
            required: true,
            message: "请输入中奖人数",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        isDefaultWinner: {
          required: true,
          message: "自主报名是否默认为中奖候选人",
          trigger: "blur"
        },
        rewardValue:[
          {
            required: true,
            trigger: "blur",
            validator: rewardValueFunc,
          },
        ],
        aliasName: {
          required: true,
          message: "请输入助力值别名",
          trigger: "blur"
        },
        shareValue:[
          {
            required: true,
            trigger: "blur",
            validator: shareValueFunc,
          },
        ],
        turntablePrizeRuleList: [
          {
            rankingSeqNum: "",
            prizeType: "1",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: "",
            prizeImg: "",
            winningRate: "",
            awardThreshold: 0,
            eachPrizeWinningUpperLimit: "",
          }
        ]
      },
      showPrizeImg: false,
      updateMode: "",
      gameBgpNew: "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/bg.png",
      gameBgpNew2: "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/title.png",
    };
  },
  computed: mapGetters(["storeStyle"]),
  watch: {},
  created() {
    this.styleType = this.$route.query.styleType;
  },
  mounted() {
    this.$store.dispatch("findCouponSendByEvent").then(res => {
      if (res.code === "0") {
        this.couponList = res.result;
      }
    });
    if (this.type) {
      this.queryDetails();
    }else{
      if(this.styleType==="virtualize"){
        this.ruleForm.gameBgp = this.gameBgpNew;
        this.ruleForm.gameBgp3 = this.gameBgpNew2;
      }
    }
    this.$store.dispatch("queryStoreStyle");
  },
  methods: {
    disabledDates(time) {
      let limtTiem = this.ruleForm.activityDate[1];
      return time.getTime() < new Date(limtTiem).getTime() - 8.64e7;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.gameId,
        gameType: "timed_draw"
      });
      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      this.ruleForm.autoOpenTime = result.autoOpenTime;
      this.ruleForm.winnerNum = result.winnerNum;
      this.ruleForm.rewardValue = result.rewardValue;
      this.ruleForm.addValue = result.addValue;
      this.ruleForm.aliasName = result.aliasName;
      this.ruleForm.shareValue = result.shareValue;
      this.ruleForm.shareTotal = result.shareTotal;
      if(this.$route.query.type === "copy"){
        this.ruleForm.totalHelpValue = 0;
      }else{
        this.ruleForm.totalHelpValue = result.totalHelpValue;
      }
      this.rules.turntablePrizeRuleList = result.storeGameTimedCharmAwardModelList;
      this.styleType2 = result.styleType;
      this.ruleForm.isDefaultWinner =
        result.isDefaultWinner;
      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];

      this.updateMode = result.updateMode;
    },
    deleteChild(index) {
      this.rules.turntablePrizeRuleList.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          // params.gameBgp2  = "https://imgcdn.hemiao100.com/mall/ps0408f174396e1ce1-2072-46e5-b50f-997e1a319920.png";
          params.timedDrawRuleModel = {
            autoOpenTime: params.autoOpenTime,
            winnerNum: params.winnerNum,
            isDefaultWinner: params.isDefaultWinner,
            styleType: this.$route.query.styleType || this.styleType2,
            rewardValue: params.rewardValue,
            addValue: params.addValue,
            aliasName: params.aliasName,
            shareValue: params.shareValue,
            shareTotal: params.shareTotal,
          };
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          params.gameType = "timed_draw";
          let name = this.type == "details" ? "editActivity" : "addTurntable";
          params.gameId = this.gameId;
          params.updateMode = this.updateMode;
          params.isLook = 'yes';
          params = Object.assign(params, {
            storeGameTimedCharmAwardModelList: this.rules.turntablePrizeRuleList,
          });
          console.log("params:",params);
          if (this.type === "edit") {
            this.$store.dispatch("editGameInfoJieLong", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          } else {
            this.$store.dispatch(name, params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    handleRemove(index) {
      this.$set(this.rules.turntablePrizeRuleList[index], "prizeImg", "");
    },
    // handleRemove(type) {
    //   if (type === "bg") {
    //     this.ruleForm.gameBgp = "";
    //   } else if(type === 'virtualize') {
    //     this.ruleForm.gameBgp3 = "";
    //   } else {
    //     this.ruleForm.gameBgp2 = "";
    //   }
    // },
    toggleShow(type) {
      this.uploadType = type;
      if (type === "bg") {
        this.imgwidth = 750;
        this.imgheight = 1334;
      } else if(type === 'virtualize') {
        this.imgwidth = 456;
        this.imgheight = 103;
      } else{
        this.imgwidth = 750;
        this.imgheight = 580;
      }
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        if (this.uploadType === "bg") {
          this.ruleForm.gameBgp = jsonData.result;
        } else if(this.uploadType=== 'virtualize') {
          this.ruleForm.gameBgp3 = jsonData.result;
        } else {
          this.ruleForm.gameBgp2 = jsonData.result;
        }
      }
    },
    cropUploadSuccess1(jsonData) {
      if (this.showPrizeImg) {
        this.currentGoods.prizeImg = jsonData.result;
        this.showPrizeImg = false;
        console.log("this.currentGoods: ", this.currentGoods);
        return;
      }
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
        this.show = false;
      }
    },
    filterGt(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      this.showPrizeImg = !this.showPrizeImg;
      this.currentGoods = v;
    },
    filterGt0OrFixed(prop, i) {
      this.rules.turntablePrizeRuleList[i][
        prop
      ] = this.rules.turntablePrizeRuleList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rules.turntablePrizeRuleList[i][
        prop
      ] = this.rules.turntablePrizeRuleList[i][prop]
        .replace(".", "")
        .replace("-", "");

      this.rules.turntablePrizeRuleList[i][
        prop
      ] = this.rules.turntablePrizeRuleList[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed0(index, prop) {
      // this.rules.turntablePrizeRuleList[index][
      //   prop
      // ] = this.rules.turntablePrizeRuleList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop].replace(/[^\d]/g, "");
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
      // console.log(this.rules.turntablePrizeRuleList[index][prop]);
      this.rules.turntablePrizeRuleList[index][prop] = new Number(
        this.rules.turntablePrizeRuleList[index][prop]
      );
    },
    filterGt0OrFixed22(index, prop) {
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rules.turntablePrizeRuleList[index][
        prop
      ] = this.rules.turntablePrizeRuleList[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.rules.turntablePrizeRuleList[index][prop].indexOf(".") < 0 &&
        this.rules.turntablePrizeRuleList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.rules.turntablePrizeRuleList[index][prop] = parseFloat(
          this.rules.turntablePrizeRuleList[index][prop]
        );
      }
    },
    
    addChild() {
      this.rules.turntablePrizeRuleList.push({
        rankingSeqNum: "",
        prizeType: "1",
        typeValue: "",
        prizeName: "",
        prizeNum: "",
        prizePriority: "",
        prizeImg: "",
        winningRate: "",
        awardThreshold: 0,
        eachPrizeWinningUpperLimit: "",
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border-radius: 6px;
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviewheadline {
  position: relative;
  width: 300px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewheadlineNew{
  width: 228px;
  height: 52px;
}
.priview {
  position: relative;
  width: 300px;
  height: 500px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  .slot {
    position: relative;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .phone-body {
    overflow: hidden !important;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .upload-img {
      top: 60px;
    }
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }      
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
    .title-img-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }
}
.header-img02{
  width: 228px;
  height: 52px;
  display: block;
  position: absolute;
  left: 50%;
  top: 77px;
  transform: translateX(-50%);
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
